import { usePaginatorControls } from '../hooks/usePaginatorControls';

type PaginatorProps = {
  onPageChange: (page: number) => void;
  currentPage: number;
  pageButtonLimit: number;
  numPages: number;
  nextPageLabel?: string;
  previousPageLabel?: string;
};

export const Paginator = ({
  onPageChange,
  currentPage,
  pageButtonLimit,
  numPages,
  nextPageLabel,
  previousPageLabel
}: PaginatorProps) => {
  const { previous, pages, next } = usePaginatorControls({
    onPageChange,
    currentPage,
    numPages,
    pageButtonLimit,
    nextPageLabel,
    previousPageLabel
  });

  return (
    <div className="reactable-pagination" data-cy="pagination">
      {previous}
      {pages}
      {next}
    </div>
  );
};
